// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.row[data-v-de9fc186]{width:auto}h2[data-v-de9fc186]{display:inline-flex;align-items:center}`, "",{"version":3,"sources":["webpack://./src/modules/main/sections/DataTable.vue"],"names":[],"mappings":"AAEA,sBACC,UAAA,CAGD,oBACC,mBAAA,CACA,kBAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
